import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
    CARD_SHADOW,
    LABEL_COLOR,
    PERIODS,
    PRIMARY,
    PRIMARY_DARK,
} from '../constants';
import type { PeriodKey } from '../types';

export const PeriodToggle = ({
    value,
    onChange,
}: {
    value: PeriodKey;
    onChange: (value: PeriodKey) => void;
}) => (
    <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_, next: PeriodKey | null) => {
            if (next) onChange(next);
        }}
        aria-label="Metrics period"
        sx={{
            bgcolor: '#fff',
            borderRadius: '12px',
            boxShadow: CARD_SHADOW,
            p: 0.5,
            gap: 0.5,
            '& .MuiToggleButtonGroup-grouped': {
                border: 0,
                borderRadius: '10px !important',
                px: 2,
                textTransform: 'none',
                fontWeight: 600,
                color: LABEL_COLOR,
                '&.Mui-selected': {
                    bgcolor: PRIMARY,
                    color: '#fff',
                    backgroundImage: `linear-gradient(135deg, ${PRIMARY}, ${PRIMARY_DARK})`,
                    '&:hover': {
                        bgcolor: PRIMARY_DARK,
                    },
                },
            },
        }}
    >
        {PERIODS.map(({ key, label }) => (
            <ToggleButton key={key} value={key}>
                {label}
            </ToggleButton>
        ))}
    </ToggleButtonGroup>
);
